module.exports = __webpack_public_path__ + "img/avatar.b1fa3987.jpg";